import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { GenericFieldAddonDirective } from './generic-field-addon.directive';
import { GenericFieldDirective } from './generic-field.directive';
import { MaskDirective } from './mask.directive';
import { GenericDateFormatDirective } from './generic-date-formats.directive';

export * from './generic-field-addon.directive';
export * from './mask.directive';
export * from './generic-field.directive';
export * from './generic-date-formats.directive';

@NgModule({
    declarations: [
        MaskDirective,
        GenericFieldDirective,
        GenericFieldAddonDirective,
        GenericDateFormatDirective,
    ],
    imports: [
        CommonModule,
    ],
    exports: [
        MaskDirective,
        GenericFieldDirective,
        GenericFieldAddonDirective,
        GenericDateFormatDirective,
    ],
})
export class GenericDirectivesModule {}
